class VariantsDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#VariantsDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.defaultFormVariants = this.querySelectorAll('.product-form__variant-label');

    document.addEventListener('defaultVariantChanged', this.close.bind(this));
    document.addEventListener('addedCartItem', this.close.bind(this));
  }

  connectedCallback() {
    this.handleVariantClickToClose();
  }


  handleVariantClickToClose(event) {
    this.defaultFormVariants.forEach((variant) => {
      variant.addEventListener('click', (event) => {
        this.close();
      });
    });
  }

  setHeaderCartIconAccessibility() {
    const variantDrawerTriggers = document.querySelectorAll('.variants-drawer__trigger');
    variantDrawerTriggers.forEach((variantDrawerTrigger) => {
      variantDrawerTrigger.setAttribute('role', 'button');
      variantDrawerTrigger.setAttribute('aria-haspopup', 'dialog');
      variantDrawerTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(variantDrawerTrigger);
      });
      variantDrawerTrigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(variantDrawerTrigger);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('VariantsDrawer');
        const focusElement = this.querySelector('.variants-drawer__inner') || this.querySelector('.variants-drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    // document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('variants-drawer', VariantsDrawer);

